export const ADD_CART_ORDER_DETAILS = 'ADD_CART_ORDER_DETAILS';
export const CLEAR_CART_ORDER_DETAILS = 'CLEAR_CART_ORDER_DETAILS';

export const CHANGE_CART_ORDER_VERSION = 'CHANGE_CART_ORDER_VERSION';
